import { fetcher } from "helpers/fetcher";

import { TCreateInsideSalesTicket, TInsideSalesTicketRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const createInsideSalesTicket = async (
  payload: TCreateInsideSalesTicket
) => {
  return await fetcher<TInsideSalesTicketRes, TCreateInsideSalesTicket["data"]>(
    ENDPOINT.MANAGEMENT.CREATE_INSIDE_SALES_TICKET,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.MANAGEMENT.CREATE_INSIDE_SALES_TICKET.version,
        [API_HEADER.BU_ID]: payload.idBu,
      },
    }
  );
};

export const mutationCreateInsideSalesTicket = async (
  payload: TCreateInsideSalesTicket
) => {
  return (await createInsideSalesTicket(payload)).data.message;
};

mutationCreateInsideSalesTicket._key = (payload: TCreateInsideSalesTicket) => [
  ENDPOINT.MANAGEMENT.CREATE_INSIDE_SALES_TICKET.url,
  payload,
];
